import dayjs from 'dayjs';

function getId(pDeal) {
  return pDeal?.id ?? '';
}
function getLinkImageDeal(pDeal) {
  return pDeal?.image ?? '';
}
function getTitleDeal(pDeal) {
  // return `${pDeal?.title} ${pDeal?.hotelInfo?.address}`;
  return pDeal?.title ?? '';
}
function getSubtitleDeal(pDeal) {
  return pDeal?.subtitle ?? '';
}
function getPriceDeal(pDeal) {
  return pDeal?.price ?? '';
}
function getIsTransfer(pDeal) {
  return pDeal?.transfer ?? false;
}
function getBaggage(pDeal) {
  return pDeal?.baggage ?? '';
}
function getType(pDeal) {
  return pDeal?.type ?? '';
}
function getTitleRemark(pDeal) {
  return pDeal?.remark?.title ?? '';
}
function getBasis(pDeal) {
  const listBasis = Object.entries(pDeal?.translations?.basisName ?? {});
  return listBasis;
}
function getTabs(pDeal) {
  return pDeal?.tabs ?? [];
}
function getTitleTab(idx, pDeal) {
  return pDeal?.tabs?.[idx]?.title ?? '';
}
function getLinkTab(idx, pDeal, marketerIdOverride) {
  if(pDeal === null) return '';
  let {host, protocol} = window.location;
  const originLink = `${pDeal?.tabs?.[idx].link}&category=${pDeal?.packageCategory ?? ''}` ?? '';
  let originUrl = new URL(originLink);

  originUrl.protocol = protocol;
  originUrl.host = host;
  if (marketerIdOverride) {
    originUrl.searchParams.set('marketerId', marketerIdOverride);
  }

  return originUrl.toString();
  // return originLink.replace('https://staging-frontend.vercel.app', 'https://bonuaf-app.vercel.app');
}
function getLink(pDeal, marketerIdOverride) {
  const link = pDeal?.link ?? '';
  if (!link) return '';
  const url = new URL(link);
  if (marketerIdOverride) {
    url.searchParams.set('marketerId', marketerIdOverride);
  }
  return url.pathname + url.search;
}
function getShareLink(pDeal) {
  return pDeal?.share ?? '';
}
function getDestCode(pDeal) {
  return pDeal?.dest ?? '';
}
function getNameDestination(pDestCode, pListDest) {
  return pListDest?.[pDestCode] ?? '';
}
function getCategoryCode(pDeal) {
  return pDeal?.category ?? '';
}
function getNameCategory(pCateCode, pListCategory) {
  const cate = pListCategory?.find((el) => el.code === pCateCode);
  return cate?.title ?? '';
}
function sortDeal(pDeal1, pDeal2) {
  // check is main deal
  if(pDeal1.isMainDeal !== pDeal2.isMainDeal) {
    return pDeal1.isMainDeal ? -1 : 1;
  }

  // check priority
  let priority = pDeal1.priority - pDeal2.priority;

  // check duration
  const startDate1 = dayjs(pDeal1.packStartDate),
    endDate1 = dayjs(pDeal1.packEndDate),
    startDate2 = dayjs(pDeal2.packStartDate),
    endDate2 = dayjs(pDeal2.packEndDate);
  if (priority === 0) {
    priority = startDate1.diff(startDate2, 'day');
  }
  if (priority === 0) {
    const duration1 = endDate1.diff(startDate1, 'day'), duration2 = endDate2.diff(startDate2, 'day');
    priority = duration1 - duration2;
  }

  // check price
  if (priority === 0) {
    priority = pDeal1.price_int - pDeal2.price_int;
  }

  return priority;
}
function getPackageCategory(pDeal) {
  return pDeal?.packageCategory ?? '';
}

function getFormatDate(date, format = 'DD/MM/YYYY') {
  return dayjs(date).format(format);
}

function getMainDeal(batch) {
  // find the deal that's isMainDeal is true and cheapest
  let lowestPrice = Infinity;
  let lowestDeal = batch[0][0];
  let mainDeal = null;

  for (let i = 0; i < batch.length; i++) {
    for (let j = 0; j < batch[i].length; j++) {
      const deal = batch[i][j];
      if (deal) {
        const price = deal.price_int;

        if (deal.isMainDeal) {
          if (!mainDeal || price < mainDeal.price_int) {
            mainDeal = deal;
          }
        }

        if (price < lowestPrice) {
          lowestPrice = price;
          lowestDeal = deal;
        }
      }
    }
  }

  return mainDeal || lowestDeal;
}

export {
  getId,
  getLinkImageDeal,
  getTitleDeal,
  getSubtitleDeal,
  getPriceDeal,
  getIsTransfer,
  getBaggage,
  getType,
  getTitleRemark,
  getBasis,
  getTabs,
  getTitleTab,
  getLinkTab,
  getLink,
  getShareLink,
  getDestCode,
  sortDeal,
  getNameDestination,
  getCategoryCode,
  getNameCategory,
  getPackageCategory,
  getFormatDate,
  getMainDeal,
};
